import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const LoginFooter = () => {
  const navigate = useNavigate();
  const currentYear = new Date()?.getFullYear();

  const footerLinks = [
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms of Service', href: '#' },
    { label: 'Help Center', href: '#' },
    { label: 'Contact Us', href: '#' }
  ];

  const socialLinks = [
    { name: 'Twitter', icon: 'Twitter', href: '#' },
    { name: 'Facebook', icon: 'Facebook', href: '#' },
    { name: 'Instagram', icon: 'Instagram', href: '#' },
    { name: 'LinkedIn', icon: 'Linkedin', href: '#' }
  ];

  return (
    <footer className="w-full bg-muted/30 border-t border-border mt-16">
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Heart" size={20} color="white" />
              </div>
              <span className="text-xl font-semibold text-foreground">Share Good</span>
            </div>
            <p className="text-sm text-muted-foreground max-w-xs">
              Connecting generous hearts with meaningful causes. 
              Join our community and make a difference together.
            </p>
            <div className="flex items-center space-x-4">
              {socialLinks?.map((social) => (
                <a
                  key={social?.name}
                  href={social?.href}
                  className="w-8 h-8 bg-background border border-border rounded-lg flex items-center justify-center hover:bg-muted transition-micro"
                  aria-label={social?.name}
                >
                  <Icon name={social?.icon} size={16} className="text-muted-foreground" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-foreground">Quick Links</h3>
            <div className="space-y-2">
              <button
                onClick={() => navigate('/cause-discovery')}
                className="block text-sm text-muted-foreground hover:text-foreground transition-micro"
              >
                Discover Causes
              </button>
              <button
                onClick={() => navigate('/giving-challenges')}
                className="block text-sm text-muted-foreground hover:text-foreground transition-micro"
              >
                Giving Challenges
              </button>
              <button
                onClick={() => navigate('/community-feed')}
                className="block text-sm text-muted-foreground hover:text-foreground transition-micro"
              >
                Community
              </button>
            </div>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-foreground">Support</h3>
            <div className="space-y-2">
              {footerLinks?.map((link) => (
                <a
                  key={link?.label}
                  href={link?.href}
                  className="block text-sm text-muted-foreground hover:text-foreground transition-micro"
                >
                  {link?.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-sm text-muted-foreground">
            © {currentYear} Share Good. All rights reserved.
          </p>
          <div className="flex items-center space-x-4 text-xs text-muted-foreground">
            <div className="flex items-center space-x-1">
              <Icon name="Shield" size={14} />
              <span>SSL Secured</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Lock" size={14} />
              <span>Privacy Protected</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LoginFooter;